/**
 * @file TabChats.jsx
 * @description TabChats component for displaying and managing tab chats.
 * @component TabChats
 * @exports TabChats - Main component for displaying and managing tab chats.
 */

import React, { useState, useEffect } from "react";
import {
  Box,
  //Typography,
  //TextField,
  //Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import { getcustomerchats} from "../../../services/customerinfoModule/historyServices";
import { fetchCustomerChatChart } from "../../../services/dashboardModule/dashboardServices";
import CustomerDashChatChart from "../../dashboard/customersDash/charts/CustomerDashChatChart";

const CustomerChats = ({customerguid, isDash = false}) => {
  // Hardcoded GUIDs for testing
  //const agentguid = localStorage.getItem("userguid");
  /* const acsIdentity = localStorage.getItem("acsIdentity");
  const workerid = localStorage.getItem("workerid");
  const userguid = localStorage.getItem("userguid"); */

  const [texts, setChats] = useState([]);
  const [loading, setLoading] = useState(false);
  const [chatsChartData, setChatsChartData] = useState([]);

  useEffect(() => {
    const fetchChart = async () => {
      try {
        const data = await fetchCustomerChatChart(customerguid);
        setChatsChartData(data || []);
      } catch (error) {
        console.error("Error fetching chat chart:", error);
      }
    };

    if(customerguid){
      fetchChats();
      if (isDash) fetchChart();
    }
  }, [customerguid, isDash]);

  const fetchChats = async () => {
    setLoading(true);
    try {
      const data = await getcustomerchats({ customerguid });
      setChats(data || []);
    } catch (error) {
      console.error("Error fetching chats:", error);
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (isoDate) => {
    const date = new Date(isoDate);
    return date.toLocaleString();
  };

  return (
    <Box sx={{ p: 2 }}>
      {isDash && (
        <CustomerDashChatChart
          rows={chatsChartData}
          title="Chat Volume"
          label="Chats"
          isCurrency={false}
        />
      )}
      {/* <Typography variant="h6" gutterBottom>
        Customer Chats
      </Typography> */}
      <TableContainer component={Paper} sx={{
          maxHeight: 500,
          overflowY: "auto",
        }}>
        <Table>
          <TableHead>
            <TableRow>  
              <TableCell><b>Customer</b></TableCell>
              <TableCell><b>Response</b></TableCell>
              <TableCell><b>Date</b></TableCell>
              <TableCell><b>Response Date</b></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {texts.length === 0 && !loading ? (
              <TableRow>
                <TableCell colSpan={3} align="center">
                  No chats found
                </TableCell>
              </TableRow>
            ) : (
              texts.map((texts, index) => (
                <TableRow key={index}>
                  <TableCell>{texts.userresponse}</TableCell>
                  <TableCell>{texts.cararesponse}</TableCell>
                  <TableCell>{formatDate(texts.userresponsetime)}</TableCell>
                  <TableCell>{formatDate(texts.cararesponsetime)}</TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default CustomerChats;

